import { combineReducers } from "redux";
import CommonReducer from "./CommonReducer";
import popup from "./popup";
import SystemSettingsReducer from "./SystemSettings";

const reducers = combineReducers({CommonReducer, popup, SystemSettingsReducer});
export default reducers;